import { defaultHttpClient } from '../../httpClient';
import type { GetSimilarGoodsResponse } from './types';

export const getSimilarGoods = (goodsSno: number) => {
  return defaultHttpClient
    .request<GetSimilarGoodsResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/similar_goods/`,
      params: {
        position: 'thumbnail',
        from: 'thumbnail',
        per_page: 4,
      },
    })
    .then(result => result.data);
};
